export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6C2 4.34315 3.34315 3 5 3H8C9.65685 3 11 4.34315 11 6V8C11 9.65685 9.65685 11 8 11H5C3.34315 11 2 9.65685 2 8V6ZM5 5C4.44772 5 4 5.44772 4 6V8C4 8.55228 4.44772 9 5 9H8C8.55229 9 9 8.55228 9 8V6C9 5.44772 8.55228 5 8 5H5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 16C2 14.3431 3.34315 13 5 13H8C9.65685 13 11 14.3431 11 16V18C11 19.6569 9.65685 21 8 21H5C3.34315 21 2 19.6569 2 18V16ZM5 15C4.44772 15 4 15.4477 4 16V18C4 18.5523 4.44772 19 5 19H8C8.55229 19 9 18.5523 9 18V16C9 15.4477 8.55228 15 8 15H5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6C13 4.34315 14.3431 3 16 3H19C20.6569 3 22 4.34315 22 6V8C22 9.65685 20.6569 11 19 11H16C14.3431 11 13 9.65685 13 8V6ZM16 5C15.4477 5 15 5.44772 15 6V8C15 8.55228 15.4477 9 16 9H19C19.5523 9 20 8.55228 20 8V6C20 5.44772 19.5523 5 19 5H16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 16C13 14.3431 14.3431 13 16 13H19C20.6569 13 22 14.3431 22 16V18C22 19.6569 20.6569 21 19 21H16C14.3431 21 13 19.6569 13 18V16ZM16 15C15.4477 15 15 15.4477 15 16V18C15 18.5523 15.4477 19 16 19H19C19.5523 19 20 18.5523 20 18V16C20 15.4477 19.5523 15 19 15H16Z"
      fill="currentColor"
    />
  </svg>
);
